"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ image }) => {
    const theme = (0, material_1.useTheme)();
    const menuItemStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0px',
        gap: '8px',
        position: 'relative',
        width: '100%',
    };
    const titleStyle = Object.assign(Object.assign({}, theme.qlub.typography.title_md), { color: theme.qlub.palette.onSurfaceColors.highEmphasis });
    const subTitleStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.mediumEmphasis });
    const descriptionStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.disabled });
    const badgeCellStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px',
        gap: '8px',
        width: '100%',
        height: '24px',
    };
    const imageStyle = {
        borderRadius: '16px',
        width: '114px',
        height: image && '112px',
    };
    return {
        menuItemStyle,
        imageStyle,
        badgeCellStyle,
        titleStyle,
        subTitleStyle,
        descriptionStyle,
    };
};
exports.default = useStyle;
